export default __webpack_public_path__ + "static/media/strasbourg5.e6d7db3c.jpg";